const brand = sessionStorage.getItem('brand');

export const shared = {
  bpDropDown: {
    placeholders: {
      search: '搜索'
    }
  },
  bpTable: {
    loadMore: '加载更多',
    view: '查看'
  },
  countryDropDown: {
    placeholders: {
      searchCountry: '搜索国家'
    }
  },
  createNew: {
    continue: '继续',
  },
  datePicker: {
    chooseADate: '选择日期',
  },
  dateRangePicker: {
    choosePeriod: '选择时段',
    today: '今天',
    lastWeek: '上周',
    lastMonth: '上个月'
  },
  demoBotModal: {
    pleaseProvideNumberForTesting: '请提供您要用于测试的号码',
    resendOtp: '重新发送 OTP',
    enterOtp: '输入 OTP',
    verifyOtp: '验证 OTP',
    sendOtp: '发送 OTP',
    cancel: '取消',
    placeholders: {
      phone: '电话*',
      enterOtp: '输入 OTP*',
    }
  },
  feedback: {
    pleaseSelectYourReason: '请选择您的原因',
    cancel: '取消',
    submit: '提交!',
    giveFeedback: '给予反馈',
    ratings: '评分',
    reasonBehindYourDecision: '您的决定背后的原因',
    shareYourExperience: '分享您的经验',
    reason1: '原因1',
    reason2: '原因2'
  },
  feedbackModal: {
    paymentIsInProgress: '支付正在进行中',
    pleaseDoNotCloseThisWindow: '请不要关闭此窗口',
    placeholders: {
      name: '姓名',
      email: '电子邮件*',
      phone: '电话*',
      pleaseShareYourUseCase: '请分享您的用例'
    }
  },
  layout: {
    sidebar: {
      notifications: '通知',
      myAccount: '我的帐户',
      logout: '注销',
      goOnline: '上线',
      manage: '管理',
      deactivate: '停用',
      activate: '激活',
      delete: '删除',
      home: '主页',
      bots: '机器人',
      inbox: '收件箱',
      analytics: '分析',
      team: '团队',
      subscriptions: '订阅',
      more: '更多',
      users: '用户',
      partnerTeam: '合作伙伴团队',
      createNewBot: '创建新机器人',
      dashboard: '仪表板',
      customers: '客户',
      partnerPanel: '合作伙伴面板',
      raiseATicket: '提出工单',
      plans: '计划',
      activities: '活动',
      feedbacks: '反馈',
      emailActivity: '电子邮件活动',
      configurations: '配置',
      copy: '复制',
      developer: '开发者',
      yourFriendWillMissYou: '你的朋友会想念你',
      rateYourBotCreationExperience: '评价您的机器人创建体验',
      whatMadeYouDeleteYourBot: '是什么让您删除您的机器人?',
      iCreatedByMistake: '我是错误创建的',
      iWantToCreateAnotherBot: '我想创建另一个机器人',
      couldNotFindFeaturesThatINeeded: '找不到我需要的功能',
      uiWasHardToNavigate: 'UI 难以导航',
      iDonotWantToTell: '我不想说',
      other: '其他',
      weWillDoOurBestToMakeAutomationFun: '我们将尽力使自动化变得有趣和简单，适用于所有人。',
      appTooltip: {
        TOOLTIP_GO_ONLINE: '切换以允许或阻止实时聊天请求',
        TOOLTIP_NOTIFICATION: '所有通知',
        TOOLTIP_MY_ACCOUNT: '您的个人资料和密码安全性',
        TOOLTIP_LOGOUT: '从仪表板注销'
      },
      modal: {
        logout: '注销',
        botDeleteFeedbackForm: '机器人删除反馈表单',
        areYouSureToLogOut: '您确定要注销吗?',
        yesIWillBeBack: '是的，我会回来',
        deleteBot: '删除机器人',
        areYouSureToDeleteBot: '您确定要删除此机器人吗?',
        cancel: '取消',
        saveAndDelete: '保存并删除'
      }
    }
  },
  modal: {
    cancel: '取消',
    yesDelete: '是的，删除!'
  },
  notify: {
    youHave: '您有',
    new: '新的'
  },
  profileIcon: {
    appTooltip: {
      weSuggestUsingYourCompanyLogo: '我们建议选择您公司的徽标。在 1 MB 以下添加 PNG 或 JPG 方形图像。'
    }
  },
  upgradeModal: {
    upgradeToKingPlan: '糟糕！Baby 计划仅提供一个免费的机器人。请升级到 King 计划以创建更多机器人。',
    noIAmGood: '不，我没事',
    iWantToUpgrade: '我想升级',
    oops: '糟糕！',
    planOfferOnlyOneFreeBot: ' 仅提供一个免费的机器人。请升级到 ',
    planToCreateMoreBots: ' 以创建更多机器人。'
  },
  webPreview: {
    preview: ' 预览',
    botsMessages: '机器人的消息',
    bot: '机器人 ',
    eleven36AM: ' 11:36 AM',
    usersReply: '用户的回复',
    landingPageBot: '首页机器人',
    chatbot: '聊天机器人',
    chat: '聊天',
    placeholders: {
      typeYourAnswer: '输入您的答案'
    }
  },
  paymentLink: {
    discardPayment: '放弃支付',
    completePayment: '完成支付',
    importantUpdate: '重要更新',
    accountUpdate: '帐户更新',
    youHave: '您有',
    exceededTheMessagesLimit: '超过消息限制',
    ofYour: '您的',
    planAnd: '计划和',
    botsAreNoLongerActive: '机器人不再活跃',
    onYourWebsite: '在您的网站上。',
    youHaveEitherIncompletePaymentOn: '您在',
    orYouHaveNotSuccessfullyUpgradedYourPlan: '或您尚未成功升级您的计划。',
    orYouHaveNotSuccessfullyWhiteLabeledYourBot: '或您尚未成功为您的机器人添加白标签。',
    orYouHaveNotSuccessfullyPurchasedTheMessagesAddOn: '或您尚未成功购买“消息附加组件”。',
    incompletePaymentMessage: '您在或您尚未成功升级您的计划。',
    please: '请',
    complete: '完成',
    upgrade: '升级',
    services: '服务',
    yourPlanToContinueServices: '您的计划以继续服务',
    yourPaymentToContinue: '您的付款以继续',
    forAnyQueryPleaseWriteUs: '如有任何疑问，请写信给我们',
    close: '关闭',
    writeOn: '',
    upgradePlan: '升级计划',
    discardModal: {
      title: '放弃支付',
      description: '您确定要放弃支付吗？',
      confirmText: '是的，放弃支付'
    },
    maintenanceHeading: '即将进行的计划维护通知：',
    maintenanceNotice: '由于维护，BotPenguin 的服务将在 2023 年 11 月 28 日晚上 7:00 至晚上 7:30 (IST) 暂时不可用。对此给您带来的不便，我们深感抱歉。我们将很快恢复正常。感谢您的理解。'
  },
  bpExport: {
    exportStatus: '导出状态',
    tasksExport: '任务-导出',
    download: '下载',
    inProgress: '进行中',
  },
  singleSession: {
    close: '关闭',
    useHere: '在此使用',
    openInAnotherWindow: `${brand} 在另一个窗口/标签中打开。单击“在此使用”以在此标签中使用 ${brand}。`
  }
};
